import { Outlet } from "react-router-dom";

const MainInvoiceIn = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainInvoiceIn;